
// Environment detection and configuration utilities
import { ENV_CONFIG, isProduction } from './config';
import { logger as structuredLogger } from '@/lib/logger';

export const ENVIRONMENT = {
  isDevelopment: () => import.meta.env.DEV,
  isProduction,
  isTest: () => import.meta.env.MODE === 'test',
  isAuthDebug: () => import.meta.env.VITE_AUTH_DEBUG === '1',
  authDebugLabel: () => import.meta.env.VITE_AUTH_DEBUG_LABEL,
} as const;

// Environment logger
export const environmentLogger = {
  debug: (message: string, ...args: any[]) => {
    if (!isProduction()) {
      structuredLogger.debug(`[DEBUG] ${message}`, { metadata: { argsCount: args.length } });
    }
  },
  
  info: (message: string, ...args: any[]) => {
    if (!isProduction()) {
      structuredLogger.info(`[INFO] ${message}`, { metadata: { argsCount: args.length } });
    }
  },
  
  warn: (message: string, ...args: any[]) => {
    if (!isProduction()) {
      structuredLogger.warn(`[WARN] ${message}`, { metadata: { argsCount: args.length } });
    }
  },
  
  error: (message: string, ...args: any[]) => {
    // Keep the detail: the first Error among the args (directly or as
    // `.error`), and the primitive fields of a context object such as
    // `{ error: 'JWT expired' }`. The structured logger redacts both.
    const error = args.find((a) => a instanceof Error)
      ?? args.find((a) => a && typeof a === 'object' && (a as { error?: unknown }).error instanceof Error)?.error;
    const metadata: Record<string, string | number | boolean | null> = { argsCount: args.length };
    const ctx = args.find((a) => a && typeof a === 'object' && !(a instanceof Error));
    if (ctx) {
      for (const [k, v] of Object.entries(ctx as Record<string, unknown>)) {
        if (v === null || ['string', 'number', 'boolean'].includes(typeof v)) metadata[k] = v as string | number | boolean | null;
      }
    }
    structuredLogger.error(`[ERROR] ${message}`, { metadata, ...(error ? { error } : {}) });
  }
};

// Legacy logger for backward compatibility
export const logger = environmentLogger;
